import { XMarkIcon } from '@heroicons/react/24/outline';

export default function DismissButton({ onClick }: { onClick: () => void }) {
    return (
        <button
            data-testid="modal-dismiss-button"
            type="button"
            className="alli-rounded-md alli-bg-white alli-text-gray-750 hover:alli-text-gray-600 focus:alli-outline-none focus:alli-ring-2 focus:alli-ring-blue-600 focus:alli-ring-offset-2"
            onClick={onClick}>
            <span className="alli-sr-only">Close</span>
            <XMarkIcon className="alli-h-6 alli-w-6" aria-hidden="true" />
        </button>
    );
}
